export default __webpack_public_path__ + "static/thanasis-psychogios-533ba80332ba686198fef407e02b595b.svg";